import React, { useState, useEffect, useContext } from 'react';
import {ReactCountryFlag} from 'react-country-flag'
import {PageTitle} from '@/_metronic/layout/core'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder';
import {DateRangeContext} from '../hooks/useDateRange';
import { useWebsite } from '../hooks/useWebsite';
import { fetchDeviceBreakdown, IDeviceBreakdown } from '../api';
import Devices from './components/Device'
import { getCountryName } from '../utils/country';

const Breadcrumbs = BreadcrumbsBuilder([
  { title: 'Home',  path: '/' },
  { title: 'Analytics',  path: '/analytics/overview' },
]);

const DevicesPage = () => {
  const {from, to, timezone} = useContext(DateRangeContext)
  const { websiteId } = useWebsite();
  const [screens, setScreens] = useState<Array<IDeviceBreakdown>>([])
  const [browsers, setBrowsers] = useState<Array<IDeviceBreakdown>>([])
  const [countries, setCountries] = useState<Array<IDeviceBreakdown>>([])

  useEffect(() => {
    const load = () => {
      fetchDeviceBreakdown(websiteId, { from, to, timezone, agg: 'screen' }).then(r => setScreens(r)).catch(() => {})
      fetchDeviceBreakdown(websiteId, { from, to, timezone, agg: 'browser' }).then(r => setBrowsers(r)).catch(() => {})
      fetchDeviceBreakdown(websiteId, { from, to, timezone, agg: 'country' }).then(r => setCountries(r)).catch(() => {})
    };
    load();
  }, [from, to, websiteId]);


  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>Devices</PageTitle>
      <div className="row">
        <div className="col-md-6">
          <Devices
            data={screens}
            title="Screens repartition"
            renderItem={(value: string) => (
              <code className="text-dark small">{value}</code>
            )}
          />

          <Devices
            data={countries}
            title="Countries repartition"
            renderItem={(value: string) => (
              <>
                {value ? (
                  <>
                    <ReactCountryFlag countryCode={value} style={{ fontSize: '1.5em' }} className="me-3"/>
                    <span className="text-gray-600 fw-bold">{getCountryName(value, 'en')}</span>
                  </>
                ) : (
                  <>Unknown</>
                )}
              </>
            )}
          />

        </div>

        <div className="col-md-6">
          <Devices
            data={browsers}
            title="Browsers repartition"
            renderItem={(value: string) => (
              <code className="text-dark small">{value}</code>
            )}
          />

        </div>
      </div>
    </>
  );
}

export default DevicesPage;
